module.exports = __webpack_public_path__ + "static/img/HAW.56c4d62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HAW.svg
// module id = uocx
// module chunks = 1